import React from 'react';

export function ErrorMessage({
  children,
}: {
  children?: string | string[];
}): React.ReactNode {
  if (typeof children === 'string') {
    return (
      <span className="hc-error-text" role="alert">
        {children}
      </span>
    );
  }

  if (Array.isArray(children)) {
    const childrenToRender = children.filter(Boolean);

    if (childrenToRender.length > 0) {
      return (
        <ul>
          {children.map((child) => (
            <li className="hc-error-text" key={child} role="alert">
              {child}
            </li>
          ))}
        </ul>
      );
    }
  }

  return null;
}
